module.exports = __webpack_public_path__ + "img/com5.2c6984b3.gif";